/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import Badge from '@atlaskit/badge/badge-new'` instead.
 */
export { default } from '../badge-new';
/**
 * @deprecated Use `import type { BadgeProps } from '@atlaskit/badge/types';` instead.
 */
export type { BadgeNewProps } from '../types';
